var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"loader"}},[_c('Lottie',{attrs:{"path":"animations/loader.json","loop":false},on:{"AnimControl":_vm.setAnimController}})],1),_c('Header'),_c('router-view'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }